"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LINKS_CAROUSEL_TITLE = exports.LINKS_CAROUSEL_ROOT = exports.LINKS_CAROUSEL_ID = exports.CAROUSEL_MOBILE_GAP = exports.CAROUSEL_DESKTOP_GAP = void 0;
const LINKS_CAROUSEL_TITLE = exports.LINKS_CAROUSEL_TITLE = 'links-carousel-title';
const LINKS_CAROUSEL_ROOT = exports.LINKS_CAROUSEL_ROOT = 'links-carousel-root';
const LINKS_CAROUSEL_ID = exports.LINKS_CAROUSEL_ID = 'editorials-links-carousel';
const CAROUSEL_MOBILE_GAP = exports.CAROUSEL_MOBILE_GAP = 10;
const CAROUSEL_DESKTOP_GAP = exports.CAROUSEL_DESKTOP_GAP = 20;
